import axios from "axios";
import config from "app/api/axiosConfig";

import { ISignedRecordsRequest } from 'app/api/types/SignedRecord';
import {DateTime} from "luxon";

export default async (token: string, data: ISignedRecordsRequest) => {
	const response = await axios.get(
		`${process.env.REACT_APP_CHAT_HOST}/Api/Records?from=${data.from}&to=${data.to}`,
		{ ...config(token), responseType: 'blob' },
	);
	const href = URL.createObjectURL(response.data);
	// create "a" HTML element with href to file & click
	const link = document.createElement('a');
	link.href = href;
	const date = DateTime.now();
	link.setAttribute('download', `report-${date.toFormat('yyyy-MM-dd')}.csv`);
	document.body.appendChild(link);
	link.click();
	// clean up "a" element & remove ObjectURL
	document.body.removeChild(link);
	URL.revokeObjectURL(href);
}
